import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  Chip,
  Button,
} from "@mui/material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Code, Storage } from "@mui/icons-material";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import ThunderstormIcon from "@mui/icons-material/Thunderstorm";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import GitHubIcon from "@mui/icons-material/GitHub";

const projects = [
  {
    id: 1,
    title: (
      <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
        <span>Alumni Path tracker </span>
        <p style={{ opacity: "0.3", fontSize: "20px" }}>
          July 25 - November 25
        </p>
      </div>
    ),
    description:
      "This Alumni Path Tracker is a group project connecting students and alumni with verified profiles, mentorship, projects, and career opportunities.",
    tags: ["React", "Node.js", "SQL"],
    icon: <Storage fontSize="large" />,
  },
  {
    id: 2,
    title: "Wanderlust",
    description:
      "Designed and implemented a seamless hotel booking platform to help users easily find and reserve their ideal stay.",
    tags: [
      "EJS",
      "Node.js",
      "Express.js",
      "MongoDB",
      "MapBox",
      "Authentication",
      "Bootstrap",
    ],
    icon: <AddHomeWorkIcon fontSize="large" />,
  },
  {
    id: 3,
    title: "Stock Market Lite",
    description:
      "Stock Market Lite is a full-stack web app that provides real-time stock data with user authentication and personalized dashboards.",
    tags: ["Node.js", "React", "Bootstrap", "MongoDB", "Firebase"],
    icon: <ShowChartIcon fontSize="large" />,
  },
  {
    id: 4,
    title: "Weather API",
    description:
      "A React-based weather app that provides real-time weather information for any city, featuring dynamic weather images to visually represent current condition.",
    tags: ["React", "Weather API", "Tailwind"],
    icon: <ThunderstormIcon fontSize="large" />,
  },
];

const Projects = () => {
  return (
    <Box
      id="projects"
      sx={{ py: 8, display: "flex", justifyContent: "center" }}
    >
      <Container
        maxWidth="lg"
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          style={{ width: "100%" }}
        >
          <Typography
            variant="h2"
            component="h2"
            gutterBottom
            align="center"
            sx={{ mb: 6 }}
          >
            Featured Projects
          </Typography>

          <Grid
            container
            spacing={4}
            sx={{
              justifyContent: "center",
              maxWidth: "1200px",
            }}
          >
            {projects.map((project, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={project.id}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  maxWidth: { sm: "400px", md: "100%" },
                }}
              >
                <motion.div
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  style={{ width: "100%" }}
                >
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: "12px",
                      overflow: "hidden",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        p: 3,
                        display: "flex",
                        justifyContent: "center",
                        color: "primary.main",
                      }}
                    >
                      {project.icon}
                    </Box>
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography gutterBottom variant="h5" component="h3">
                        {project.title}
                      </Typography>
                      <Typography sx={{ mb: 2 }}>
                        {project.description}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1,
                          mb: 3,
                        }}
                      >
                        {project.tags.map((tag) => (
                          <Chip
                            key={tag}
                            label={tag}
                            size="small"
                            sx={{
                              fontFamily: '"Roboto Mono", monospace',
                              fontSize: "0.7rem",
                            }}
                          />
                        ))}
                      </Box>
                      <Button
                        component={Link}
                        to={`/projects/${project.id}`}
                        state={{ from: "projects" }}
                        variant="outlined"
                        fullWidth
                        startIcon={<Code />}
                        sx={{
                          fontWeight: 600,
                          borderWidth: "2px",
                          "&:hover": {
                            borderWidth: "2px",
                          },
                        }}
                      >
                        View Project
                      </Button>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>

          {/* View More Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 6,
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <Button
                href="https://github.com/shimul47"
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                size="large"
                startIcon={<GitHubIcon />}
                sx={{
                  fontWeight: 600,
                  px: 4,
                  py: 1.5,
                }}
              >
                View More on GitHub
              </Button>
            </motion.div>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Projects;
